import {
  BottomSheetBody,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  classNames,
  Flex,
  FlexColumn,
  ItemContent,
  ItemDescription,
  ItemSide,
  ItemTitle,
  Separator,
  SkeletonBlock,
  TextBody,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { ActionTimelineSkeleton } from "../../../components/ActionTimeline"
import { Item } from "../../../components/Item"

type CheckoutFlowSkeletonProps = {
  count: number
  isClaim?: boolean
}

export function CheckoutFlowSkeleton({
  count,
  isClaim,
}: CheckoutFlowSkeletonProps) {
  const t = useTranslations("wallet.CheckoutFlow")
  return (
    <>
      <BottomSheetHeader>
        <Flex className="flex-col">
          <BottomSheetHeaderTitle>
            {isClaim ? t("claimTitle") : t("title")}
          </BottomSheetHeaderTitle>
          {isClaim && (
            <TextBody className="mt-1 text-text-secondary" size="sm">
              {t("claimSubtext")}
            </TextBody>
          )}
        </Flex>
      </BottomSheetHeader>
      <BottomSheetBody>
        <Flex className="size-full flex-col gap-10 md:flex-row">
          <FlexColumn className="w-full">
            <FlexColumn className="max-h-36 overflow-y-auto">
              {new Array(count).fill(0).map((_, i) => (
                <Item className="py-4" key={i} variant="unstyled">
                  <SkeletonBlock
                    className={classNames(
                      "order-1 size-12 shrink-0 rounded text-text-primary",
                    )}
                  />
                  <ItemContent>
                    <ItemTitle>
                      <SkeletonBlock className="h-4 w-16" />
                    </ItemTitle>
                  </ItemContent>
                  <ItemSide className="items-end">
                    <ItemTitle>
                      <SkeletonBlock className="h-4 w-16" />
                    </ItemTitle>
                    <ItemDescription className="mt-1.5">
                      <SkeletonBlock className="h-4 w-10" />
                    </ItemDescription>
                  </ItemSide>
                </Item>
              ))}
            </FlexColumn>

            {/* Gas */}
            {/*<Item variant="unstyled" className="py-4">
              <ItemContent>
                <ItemTitle>
                  <ItemTitle>Gas</ItemTitle>
                </ItemTitle>
              </ItemContent>
              <ItemSide className="items-end">
                <ItemTitle>
                  <SkeletonBlock className="h-4 w-24" />
                </ItemTitle>
                <ItemDescription className="mt-1.5">
                  <SkeletonBlock className="h-4 w-10" />
                </ItemDescription>
              </ItemSide>
            </Item>*/}

            {!isClaim && (
              <>
                <Separator className="my-2" />

                {/* Total */}
                <Item className="py-4" variant="unstyled">
                  <ItemContent>
                    <ItemTitle>{t("total")}</ItemTitle>
                  </ItemContent>
                  <ItemSide className="items-end">
                    <ItemTitle>
                      <SkeletonBlock className="h-4 w-16" />
                    </ItemTitle>
                    <ItemDescription className="mt-1.5">
                      <SkeletonBlock className="h-4 w-10" />
                    </ItemDescription>
                  </ItemSide>
                </Item>
              </>
            )}
          </FlexColumn>

          <Separator
            className="hidden h-auto md:block"
            orientation="vertical"
          />

          <FlexColumn className="w-full min-w-0">
            {!isClaim && (
              <>
                <TextBody
                  className="mb-4 uppercase"
                  color="text-secondary"
                  size="xs"
                  weight="semibold"
                >
                  {t("paymentMethod")}
                </TextBody>

                <SkeletonBlock className="h-20 w-full rounded" />
                <Separator className="my-6" />
              </>
            )}
            <ActionTimelineSkeleton count={1} />
          </FlexColumn>
        </Flex>
      </BottomSheetBody>
    </>
  )
}
